var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.28039 0.219725C0.987523 -0.0731986 0.512649 -0.073248 0.219725 0.219615C-0.0731986 0.512477 -0.073248 0.987351 0.219615 1.28027L7.29655 8.35869L0.227421 15.4278C-0.0654718 15.7207 -0.0654718 16.1956 0.227421 16.4885C0.520315 16.7814 0.995188 16.7814 1.28808 16.4885L8.3571 9.41946L15.4405 16.5043C15.7333 16.7972 16.2082 16.7973 16.5011 16.5044C16.794 16.2115 16.7941 15.7367 16.5012 15.4437L9.41776 8.3588L16.4962 1.28033C16.7891 0.987437 16.7891 0.512563 16.4962 0.21967C16.2033 -0.0732233 15.7285 -0.0732233 15.4356 0.21967L8.35721 7.29803L1.28039 0.219725Z",
    fill: "#2F4858"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8ace178e.svg";
export { ForwardRef as ReactComponent };